// Modal condiviso che mostra i movimenti contabili collegati a un'iscrizione
// extra (match su alunno + anno competenza + causale). Usato da Log Iscrizioni
// e da Corsi >> Alunni. Feb 2026: supporta anche match_mode "cau1_iscrizione"
// per Segremat Web Pro > Alunni e > Curriculum (movimenti Cau=1 Iscrizione).
export default function MovimentiCollegatiModal({ data, onClose }) {
  const { iscr, data: resp } = data || {};
  const fmt = (s) => s ? String(s) : "—";
  const isCau1 = resp?.match_mode === "cau1_iscrizione";
  const titolo = isCau1
    ? "💰 Movimenti ISCRIZIONE (Cau=1)"
    : "💰 Movimenti contabili collegati";
  const subLine = isCau1
    ? <><b>{iscr.cognome} {iscr.nome}</b> · cod {iscr.alunno_cod} · A.S. {iscr.anno}</>
    : <><b>{iscr.cognome} {iscr.nome}</b> · cod {iscr.alunno_cod} · {iscr.corso_descrizione || iscr.corso_codice} · A.S. {iscr.anno}</>;
  return (
    <div onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} data-testid="mov-modal"
        style={{ background: "white", maxWidth: 1100, width: "100%", maxHeight: "90vh", overflow: "auto", borderRadius: 6, padding: 20, boxShadow: "0 8px 32px rgba(0,0,0,0.4)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12, borderBottom: "2px solid #1565c0", paddingBottom: 8 }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#0d47a1" }}>{titolo}</div>
            <div style={{ fontSize: 11, color: "#666", marginTop: 4 }}>{subLine}</div>
            {!isCau1 && (
              <div style={{ fontSize: 11, color: "#6a1b9a", marginTop: 4 }}>
                Match: causale corso <code style={{ background: "#fff9c4", padding: "1px 6px", fontFamily: "Consolas, monospace" }}>&quot;{resp.causale_corso || "(vuota!)"}&quot;</code> = Cau (codice) o CauDes (descrizione) movimento · alunno {resp.alunno_cod} · anno {resp.anno}
              </div>
            )}
            {isCau1 && (
              <div style={{ fontSize: 11, color: "#6a1b9a", marginTop: 4 }}>
                Match: <code style={{ background: "#fff9c4", padding: "1px 6px", fontFamily: "Consolas, monospace" }}>Cau = 1</code> (Iscrizione) · alunno {resp.alunno_cod} · anno {resp.anno}
              </div>
            )}
            <div style={{ fontSize: 10, color: "#1b5e20", marginTop: 6, background: "#e8f5e9", padding: 6, borderLeft: "3px solid #2e7d32", borderRadius: 2 }}>
              <b>REGOLE DI MATCH APPLICATE</b>:
              <span style={{ marginLeft: 6 }}>① <code>movimento.Alu = {resp.alunno_cod}</code></span>
              <span style={{ marginLeft: 6 }}>② <code>movimento.anno = {resp.anno}</code> (anno scolastico erogazione · Segremat: Area)</span>
              <span style={{ marginLeft: 6 }}>③ {isCau1
                ? <code>movimento.Cau = 1 (Iscrizione)</code>
                : <code>movimento.CauDes/Cau = &quot;{resp.causale_corso}&quot;</code>
              }</span>
            </div>
            {resp.warning && (
              <div style={{ marginTop: 6, padding: 6, background: "#fff3e0", color: "#bf360c", fontSize: 11, fontWeight: 700, borderRadius: 2 }}>⚠ {resp.warning}</div>
            )}
          </div>
          <button onClick={onClose} style={{ background: "#c62828", color: "white", border: "none", padding: "6px 14px", fontSize: 14, fontWeight: 700, cursor: "pointer", borderRadius: 3 }}>✕</button>
        </div>
        <div style={{ display: "flex", gap: 16, marginBottom: 10, fontSize: 13 }}>
          <span><b>Movimenti trovati:</b> <span style={{ color: "#0d47a1", fontWeight: 800 }}>{resp.count}</span></span>
          <span><b>Totale:</b> <span style={{ color: (resp.totale || 0) >= 0 ? "#1b5e20" : "#c62828", fontWeight: 800, fontFamily: "Consolas, monospace" }}>€ {(resp.totale || 0).toFixed(2)}</span></span>
          {!isCau1 && (
            <span><b>Prezzo iscrizione:</b> <span style={{ fontFamily: "Consolas, monospace" }}>€ {(Number(iscr.prezzo) || 0).toFixed(2)}</span></span>
          )}
        </div>
        {resp.count === 0 ? (
          <div style={{ padding: 30, textAlign: "center", color: "#888", fontStyle: "italic", background: "#fafafa", borderRadius: 4 }}>
            {isCau1
              ? <>Nessun movimento <b>Cau=1 (Iscrizione)</b> per questo alunno nell&apos;anno {resp.anno}.</>
              : (<>Nessun movimento trovato con questi criteri.<br/>Verifica che la <b>causale del corso</b> sia configurata correttamente (Lista Corsi → colonna CAUSALE).</>)
            }
          </div>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
            <thead>
              <tr style={{ background: "#eceff1", color: "#37474f" }}>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0" }}>NUM</th>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0" }}>ALU</th>
                <th style={{ padding: "6px 8px", textAlign: "center", borderBottom: "2px solid #1565c0" }} title="Anno scolastico erogazione (campo `anno`, in Segremat: Area). NON AnnCom (anno contabile fattura).">A.COMP.</th>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0" }}>DATA DOC</th>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0" }}>DATA PAG</th>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0" }}>TIPO</th>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0" }}>CAUSALE</th>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0", maxWidth: 400 }}>DESCRIZIONE</th>
                <th style={{ padding: "6px 8px", textAlign: "left", borderBottom: "2px solid #1565c0" }}>MODALITÀ</th>
                <th style={{ padding: "6px 8px", textAlign: "right", borderBottom: "2px solid #1565c0" }}>IMPORTO</th>
              </tr>
            </thead>
            <tbody>
              {resp.items.map((m, i) => {
                const neg = (m.Est || "").toLowerCase() === "neg";
                const imp = Number(m.Imp) || 0;
                // 🆕 Anno competenza scolastico = campo `anno` (Segremat: Area).
                // NON usare AnnCom (anno contabile fattura).
                const annoComp = m.anno;
                const okAlu  = String(m.Alu) === String(resp.alunno_cod);
                const okAnno = Number(annoComp) === Number(resp.anno);
                const ruleViolation = !(okAlu && okAnno);
                const rowBg = ruleViolation ? "#ffebee" : (i % 2 ? "#fafafa" : "white");
                return (
                  <tr key={i} style={{ borderBottom: "1px solid #eee", background: rowBg }}>
                    <td style={{ padding: "5px 8px", fontFamily: "Consolas, monospace", fontWeight: 700 }}>{m.Num}</td>
                    <td style={{ padding: "5px 8px", fontFamily: "Consolas, monospace", color: okAlu ? "#0d47a1" : "#c62828", fontWeight: 700 }}>{m.Alu}</td>
                    <td style={{ padding: "5px 8px", fontFamily: "Consolas, monospace", textAlign: "center", color: okAnno ? "#0d47a1" : "#c62828", fontWeight: 800 }} title={`anno=${m.anno} · AnnCom=${m.AnnCom}`}>{annoComp != null ? annoComp : "—"}</td>
                    <td style={{ padding: "5px 8px", fontFamily: "Consolas, monospace" }}>{fmt(m.DtaDoc)}</td>
                    <td style={{ padding: "5px 8px", fontFamily: "Consolas, monospace", color: "#1b5e20" }}>{fmt(m.DtaPag)}</td>
                    <td style={{ padding: "5px 8px" }}>{fmt(m.TipDoc)}</td>
                    <td style={{ padding: "5px 8px", fontWeight: 700, color: "#6a1b9a" }}>{fmt(m.CauDes)}</td>
                    <td style={{ padding: "5px 8px", maxWidth: 400, wordBreak: "break-word" }}>{fmt(m.Des)}</td>
                    <td style={{ padding: "5px 8px", fontSize: 10, color: "#555" }}>{fmt(m.ModDes)}</td>
                    <td style={{ padding: "5px 8px", textAlign: "right", fontFamily: "Consolas, monospace", fontWeight: 700, color: neg ? "#c62828" : "#1b5e20" }}>
                      {neg ? "−" : ""}€ {imp.toFixed(2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
